/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GIOwnershipJsonApiModel = {
  id: "",
  "units-transacted": "",
  "units-balance": "",
  "account-value": "",
  "effective-date": "",
  description: "",
  "transaction-type": "",
  "offering-name": "",
  "offering-status": "",
  amount: "",
  "is-imported": "",
};
